import { useEffect, useState } from "react";
import { useAuth, IMPERSONATOR_KEY } from "../context/AuthContexts";

/**
 * Slim fixed bar shown while an admin is "logged in as" another user.
 * Reads the impersonation backup from localStorage and re-checks whenever the
 * auth state changes (the context dispatches an "auth:updated" event).
 */
export default function ImpersonationBanner() {
  const { user, exitImpersonation } = useAuth();
  const [active, setActive] = useState(false);
  const [adminLabel, setAdminLabel] = useState<string>("administrator");

  useEffect(() => {
    const sync = () => {
      const raw = localStorage.getItem(IMPERSONATOR_KEY);
      if (!raw) { setActive(false); return; }
      setActive(true);
      try { setAdminLabel(JSON.parse(raw)?.label || "administrator"); } catch { /* ignore */ }
    };
    sync();
    window.addEventListener("auth:updated", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("auth:updated", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  if (!active) return null;

  const who = user?.name || user?.email || "this user";

  return (
    <div className="fixed top-0 inset-x-0 z-[9999] bg-amber-500 text-amber-950 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 px-4 py-2 text-sm font-semibold text-center">
        <span>
          You are logged in as <span className="font-black">{who}</span> — signed in by {adminLabel}.
        </span>
        <button
          onClick={() => {
            exitImpersonation();
            window.location.href = "/member-list"; // full reload back to admin area
          }}
          className="ml-2 px-3 py-1 rounded-lg bg-amber-950 text-white text-xs font-bold hover:bg-black transition-colors"
        >
          Exit impersonation
        </button>
      </div>
    </div>
  );
}
